export const interpolateString = (template, values) =>
  template.replace(/{{(\w+)+}}/g, (match, key) => values?.[key] || match);
